<template>
  <div class="wrapper article-level-four" :class="'theme-' + theme">
    <div class="card">
      <div class="card-block">
        <div class="card-title">
          <node-link
            :url="node.relative_url"
            :type="node.type"
            :nid="node.nid"
            :title="node.title"
            :destinationTid="destinationTid"
            gtm-on="click"
            gtm-event-action="Scroll Article/Click/Also Read"
            :gtm-event-label="`${node.relative_url}`"
            >{{title}}</node-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import get from 'lodash/get'
import NodeLink from 'components/node/Link'
import mixinSection from 'components/mixins/section'

import { getSocialHeadLingAsTitle } from 'mixins/utilities'

export default {
  name: 'article-level-four',
  mixins: [mixinSection],
  props: {
    node: {
      type: Object, // include: relative_url, title
      default: () => ({}),
    },
    theme: {
      type: String,
      default: 'default',
    },
  },
  components: {
    NodeLink,
  },
  data() {
    return {}
  },
  computed: {
    title() {
      return getSocialHeadLingAsTitle(this.node)
    },
    destinationTid() {
      return get(this.getLastSection(get(this, 'node.sections', [])), 'tid', false)
    },
  },
}
</script>
<style scoped lang="scss">
  .article-level-four {
    font-family: $barlow;
    &.theme-dark .card-title a{
      color: $white;
    }
    .card {
      border: none;
      background-color: transparent;
    }
    .card-block {
      @include respond-to('desktop') {
        padding: rem-calc(10 0 14);
      }
      @include respond-to('mobile') {
        padding: rem-calc(8 0 12);
      }
    }
    .card-title {
      margin-bottom: 0;
      a{
        @include respond-to('desktop') {
          font-size: rem-calc(28);
          line-height: rem-calc(34);
        }
        @include respond-to('mobile') {
          font-size: rem-calc(20);
          line-height: rem-calc(26);
        }
        &.theme-dark {
          color: $white;
        }

        color: $black;
        font-weight: bold;
        padding-bottom: rem-calc(2);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Lv4.vue?fec60f8a